// Resuelve actores a nombres con la sesión y, si hay permiso, con el padrón de usuarios del tenant.
import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { tenantApi } from '@/api/endpoints/tenant';
import { actorLabel } from '@/lib/actorLabel';
import { useAuth } from './useAuth';

const USER_DIRECTORY_PERMISSIONS = ['tenant.user.list', 'tenant.user.read'] as const;

export function useActorLabel(): (actor: string | null | undefined) => string {
    const { t } = useTranslation('common');
    const { user, permissions } = useAuth();
    const tenantId = user?.tenantId ?? '';
    const canList = USER_DIRECTORY_PERMISSIONS.some((key) => permissions.has(key));
    const users = useQuery({
        queryKey: ['tenant', tenantId, 'users', 'actor-directory'],
        queryFn: () => tenantApi.listUsers(tenantId, { pageSize: 200 }),
        enabled: tenantId !== '' && canList,
        staleTime: 5 * 60_000,
        retry: false,
    });
    const names = useMemo(
        () => new Map((users.data?.items ?? []).map((u) => [u.cognitoSub, u.displayName])),
        [users.data],
    );
    const selfSub = user?.cognitoSub ?? null;
    const selfName = user?.displayName || user?.email || null;
    return useCallback(
        (actor) => actorLabel(actor, { selfSub, selfName, names }, t),
        [selfSub, selfName, names, t],
    );
}
